import React from "react";
import FailuresTable from "../../default/FailuresTable";

const TableAll: React.FC = () => {
  return <FailuresTable />;
};

export default TableAll;
